module.exports = __webpack_public_path__ + "img/marker-orange.cb2da4b2.svg";